import './carousel-card.scss'

import React from 'react'

import Card from '../card/card'

const config = {
  className: 'carousel-card',
  minicard: true,
  hasNoImage: true,
  hasUnderline: false,
  hasNoLocationDisplay: true,
  isSearch: false,
  isCarousel: true,
}

export const CarouselCard = ({ item }) => <Card item={item} {...config} />
